// CacheKey 401cc06a4018ae724b0d62bb5be393fe
//
// DO NOT MODIFY: This file was automatically generated by JsFromTranslations.
export default {
  "en-ARCH_CARE": {
    filters: {
      mrn: {
        label: "Member ID"
      },
      patient: {
        label: "Member",
        title: "Filter by member"
      },
      patient_tags: {
        label: "Member Tags",
        title: "Filter by member tags"
      },
      tags: {
        title: "Filter by member tags"
      },
      unit: {
        label: "Team Number",
        title: "Filter by team number"
      }
    },
    search: {
      defaults: {
        filters: {
          patient: {
            name: "Member Name"
          },
          encounter: {
            mrn: "Member ID",
            provider_patient_id: "Member ID",
            unit_id: "Team Number",
            unit_short_title: "Team Number"
          },
          issue: {
            unit_id: "Team Number",
            unit_short_title: "Team Number",
            current_unit: "Current Team Number"
          },
          unit: {
            short_title: "Team Number"
          }
        }
      },
      patients: {
        items: "members"
      },
      patients_modal: {
        items: "members"
      },
      patient_tasks: {
        empty: {
          message: "There are no {{item}} for this member due in the next seven days."
        }
      },
      units: {
        items: "team numbers"
      }
    }
  }
}

